module.exports = __webpack_public_path__ + "img/support.ab7c4e7d.svg";